import { data } from '../../svg/AutoDelete/data';
import { makeIcon } from '../makeIcon';

export const AutoDelete = makeIcon(data, 'auto_delete', 'AutoDelete');

export default AutoDelete;
